import React, {useState} from 'react'
import './EditCensorModal.css'


export default function CreateTestGroupModal({schoolID, onCreate, onClose}){


    const [formData, setFormData] =useState({
        navn: '', 
        sprogcenter_id: schoolID,
        termin_id: 0, 
        underviser_id: 0, 
        censor_id: 0
    })




    function handleSubmit(e){
        e.preventDefault()
        onCreate(formData)
    }

    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="modal-title">Opret prøvegruppe</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={(e)=>handleSubmit(e)}>
                    <div className="modal-form-grid">
                        <div className="form-group">
                            <label>Prøvegruppenavn:</label>
                            <input type="text" value={formData.navn}
                                onChange={(e)=>setFormData({...formData, navn: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Termin:</label>
                            <input type="text" value={formData.termin_id}
                                onChange={(e)=>setFormData({...formData, termin_id: e.target.value})}/>
                        </div>
                        <div className="form-group"
                            type="text" value={formData.underviser_id}
                            onChange={(e)=>setFormData({...formData, underviser_id: e.target.value})}/>
                    </div>
                    <div className="modal-actions" style={{marginTop: '20px'}}>
                        <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
                        <button type="submit" className="btn-save">Opret prøvegruppe</button> 
                    </div>
                </form>

            </div>
        </div>
    )
}